// extracted by mini-css-extract-plugin
export var listingBtn = "style-module--listingBtn--cc44c";
export var navigation = "style-module--navigation--58ca3";
export var searchOpenScrolled = "style-module--search-open-scrolled--b1178";
export var switchInvestorBtn = "style-module--switchInvestorBtn--88e4d";